<div [id]="field.attributes.id" (blur)="touch()">
  <regions-selector
    [regions]="regions"
    [(selected)]="value"
    [disabled]="disabled"
    [changeServiceToUniversal]="changeServiceToUniversal"
    [readonly]="readonly"
  ></regions-selector>
</div>
